import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LoadingScreen } from './ui/LoadingScreen';

export function ProtectedRoute({ children, allowedUserTypes }) {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingScreen label="A validar sessão…" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedUserTypes && !allowedUserTypes.includes(user?.user_type)) {
    // Redirect to appropriate dashboard
    let redirectPath = '/';
    if (user?.user_type === 'buyer') {
      redirectPath = '/buyer/dashboard';
    } else if (user?.user_type === 'agent') {
      redirectPath = '/agent/dashboard';
    } else if (user?.user_type === 'admin') {
      redirectPath = '/admin';
    }
    return <Navigate to={redirectPath} replace />;
  }

  return children;
}
